
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Logo } from '@/components/ui/Logo';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';

export const PublicHeader = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="bg-midnight-green/95 backdrop-blur-sm border-b border-copper/20 sticky top-0 z-50 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center cursor-pointer">
              <Logo variant="horizontal" size="md" className="brightness-0 invert" />
            </Link>
          </div>
          <nav className="hidden md:flex items-center gap-8">
            <Link to="/#features" className="font-inter text-ivory/90 hover:text-copper transition-colors text-sm font-medium">Features</Link>
            <Link to="/use-cases" className="font-inter text-ivory/90 hover:text-copper transition-colors text-sm font-medium">Use Cases</Link>
            <Link to="/about" className="font-inter text-ivory/90 hover:text-copper transition-colors text-sm font-medium">About</Link>
            <Link to="/pricing" className="font-inter text-ivory/90 hover:text-copper transition-colors text-sm font-medium">Pricing</Link>
            <Link to="/contact" className="font-inter text-ivory/90 hover:text-copper transition-colors text-sm font-medium">Contact</Link>
          </nav>
          <div className="hidden md:flex items-center gap-3">
            <Button asChild variant="ghost" className="text-ivory hover:text-copper hover:bg-white/10">
              <Link to="/auth">Sign In</Link>
            </Button>
            <Button asChild className="bg-copper hover:bg-copper/90 text-ivory font-semibold shadow-lg">
              <Link to="/contact">Request Demo</Link>
            </Button>
          </div>
          <button className="md:hidden text-ivory p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-copper/20">
            <nav className="flex flex-col gap-4">
              <Link to="/#features" className="font-inter text-ivory/90 hover:text-copper transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>Features</Link>
              <Link to="/use-cases" className="font-inter text-ivory/90 hover:text-copper transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>Use Cases</Link>
              <Link to="/about" className="font-inter text-ivory/90 hover:text-copper transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>About</Link>
              <Link to="/pricing" className="font-inter text-ivory/90 hover:text-copper transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>Pricing</Link>
              <Link to="/contact" className="font-inter text-ivory/90 hover:text-copper transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>Contact</Link>
              <div className="flex flex-col gap-2 pt-4 border-t border-copper/20">
                <Button asChild variant="outline" className="bg-ivory text-midnight-green border-ivory hover:bg-ivory/90">
                  <Link to="/auth" onClick={() => setMobileMenuOpen(false)}>Sign In</Link>
                </Button>
                <Button asChild className="bg-copper hover:bg-copper/90 text-ivory">
                  <Link to="/contact" onClick={() => setMobileMenuOpen(false)}>Request Demo</Link>
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
